import type { SVGProps } from "react";
export default function SvgClosePanel(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-panel-left-close-icon lucide-panel-left-close"
			viewBox="0 0 24 24"
			{...props}
		>
			<rect width={18} height={18} x={3} y={3} rx={2} />
			<path d="M9 3v18" />
			<path d="m16 15-3-3 3-3" />
		</svg>
	);
}
